import React, { Component } from "react";
import {
  Row,
  Table,
  Button,
  Alert,
  ModalHeader,
  Modal,
  ModalBody,
  Input,
} from "reactstrap";
import { CSVLink } from "react-csv";
import Toggle from "react-toggle";
import axios from "../../../../../axios";
import * as url from "../../../../../utils/url";
import findIndex from "lodash/findIndex";
import Checkbox from "rc-checkbox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from "../../../../../modules/actions/index";
import moment from "moment";
import {
  groupContentFields,
  calculateTotalRsvp,
  getDuration,
  uploadPreview,
  whiteLabelStyling,
  trim_str,
  displayEventDates,
  removePhraseBetweenCommas,
  renderGenderPronoun,
  profilePicValidityCheck,
} from "../../../../../utils/constants";
import EventGuestsModal from "../../../../../components/EventGuestList/EventGuestsModal";
import groupIcon from "../../../../../assets/placeholders/group.svg";
import { first } from "lodash";
import { toDateObject } from "react-multi-date-picker";
import { BiMap } from "react-icons/bi";
import EventsMap from "../../../../../components/AddressSearch/EventsMap";

const eventUsersHeaders = [
  {
    label: "Name",
    key: "name",
  },

  {
    label: "Email",
    key: "email",
  },
  {
    label: "Invited On",
    key: "invitedOn",
  },
  {
    label: "Status",
    key: "status",
  },
];

class EventAbout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGuestList: false,
      invited_length: 0,
      interested_length: 0,
      going_length: 0,
      updatedItem: this.props.item,
      invitedUsers: [],
    };
  }

  componentDidMount() {
    this.setState({ updatedItem: this.props.item });
    let payload = {
      eventId: this.props.match.params.id,

      noLoader: true,
      // organizationId: this.props.item.organizationID
    };

    axios
      .post(url.findEventGuests, payload)
      .then((resp) => {
        const data = resp.data.data;
        this.setState({ invitedUsers: data });
      })
      .catch((err) => console.log(err));
  }

  componentDidUpdate(prevProps, prevState) {}

  checkIfNameExists = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    let result = "";
    if (user.label && user.label != "" && firstName == "N" && lastName == "N") {
      result = user.label;
    }
    return result;
  };

  getInitials = (user) => {
    let result = "";
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    result =
      firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();

    if (user.label && user.label != "" && firstName == "N" && lastName == "N") {
      let name = this.checkIfNameExists(user);
      let name_arr = name.split(",");

      result =
        trim_str(name_arr[0])
          .charAt(0)
          .toUpperCase() +
        trim_str(name_arr[1])
          .charAt(0)
          .toUpperCase();
    }
    return result;
  };

  createMarkup = (input) => {
    return { __html: `<div>${input}</div>` };
  };

  check_if_usr_member = (tool, current_user) => {
    // return tool.members && tool.members.filter(e=> e.o_id.toString() == current_user._id.toString()).length>0
    return (
      tool.createdBy._id == current_user._id ||
      this.props.curr_rsvp ||
      (current_user.groups &&
        current_user.groups.length > 0 &&
        current_user.groups.filter(
          (e) => e.o_id.toString() == tool.groupId.toString()
        ).length > 0)
    );
  };

  removeImage = (photo) => {
    const { attachments, _id } = this.props.item;
    const updated_attachments = attachments.filter((x) => x.url !== photo.url);
    axios
      .post(url.removeToolAttachments, {
        toolId: _id,
        attachments: updated_attachments,
      })
      .then(({ data }) => {
        console.log("data.data.attachments",data.data)
        this.props.updateAttachments(data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  renderUploadPreview = (source) => {
    return source.map((photo, idx) => {
      let { size, url } = photo;
      let img = uploadPreview(photo);
      let { preview, isMsIcon } = img;
      let mb = 1024 * 1024;
      let file_size;
      if (size) {
        file_size =
          size >= mb
            ? `${(size / mb).toFixed(2)}mb`
            : `${(size / 1024).toFixed(2)}kb`;
      } else {
        file_size = null;
      }

      return (
        <span
          key={idx}
          className={
            photo.isAccepted == false
              ? "taskUploadPreviewImg rejectedFilesContainer"
              : "taskUploadPreviewImg"
          }
        >
          <img src={preview} className="fileUploadSize" />
          {this.props.item.createdBy._id == this.props.user._id ? (
            <span
              key={preview + idx}
              onClick={() => this.removeImage(photo)}
              className="removeTaskUpload"
            >
              <span className="flaticon-trash" />
            </span>
          ) : null}
          <div className="previewTaskImageText">
            <span className="previewTaskImageTitle">{photo.name}</span>
            <span className="previewTaskImageTitle">{file_size}</span>
            {(this.props.item &&
              this.props.item.groupId &&
              this.props.item.privacy == "PRIVATE" &&
              this.check_if_usr_member(this.props.item, this.props.user)) ||
            this.props.item.privacy != "PRIVATE" ? (
              <span className="taskAttachmentContent">
                <a href={url} target="_blank">
                  Download
                </a>{" "}
                ({file_size})
              </span>
            ) : null}
          </div>
        </span>
      );
    });
  };

  goToWebinar = (val) => {
    window.open(val, "_blank");
  };

  goOwnerProfile = (user) => {
    let orgId, userId;
    let { organizationId, _id } = this.props.user;

    if (user.hasOwnProperty("organizationId")) {
      orgId = user.organizationId._id;
    } else {
      orgId = organizationId._id;
    }

    if (user.hasOwnProperty("value")) {
      userId = user.value;
    } else {
      userId = _id;
    }

    let link = `/home/${orgId}/profile/${userId}`;
    this.props.history.push(link);
  };

  showGuestList = () => {
    this.setState({ showGuestList: true });
  };

  closeGuestList = () => {
    this.setState({ showGuestList: false });
  };

  goToGroup = () => {
    this.props.history.push(
      `/home/groups/${this.props.user.organizationId._id}/view/${this.props.item.groupId}`
    );
  };

  renderHosts = () => {
    return this.props.item.invitedUsers.map((e, idx) => {
      return (
        <div
          className="grp_create_page_privacy_status_details"
          onClick={() => this.goOwnerProfile(e)}
          key={e.value + idx}
        >
          <div className="">
            {profilePicValidityCheck(e.profilePic) ? (
              <img
                src={e.profilePic}
                className="event_category_item_host_image"
              />
            ) : (
              <span
                className="event_category_item_host_image_initials"
                data-letters={this.getInitials(e)}
              ></span>
            )}
            <span className="event_category_item_host_image_name">
              {e.firstName || e.lastName
                ? `${e.firstName} ${e.lastName}`
                : this.checkIfNameExists(e)}
            </span>

            <div className="text-center">
              <span className="user_gender_pronoun_toolsview">
                {renderGenderPronoun(e)}
              </span>
            </div>
          </div>
        </div>
      );
    });
  };

  // updateEventRsvp=(toolUpdate)=>{
  //  this.props.updateEventRsvp(toolUpdate)
  //   let tool_attr = [
  //     'invitee_count', 'attendee_count', 'rsvp_count', 'interested_count','going_count',
  //   ]

  //   let updated_item = Object.keys(toolUpdate)
  //                     .filter(e=> tool_attr.indexOf(e)>-1)
  //                     .reduce((acc, key)=>{ acc[key]=toolUpdate[key]; return acc}, {})

  //   this.props.onToolInfoCompleted(updated_item)
  // }

  getEventsUsersData = () => {
    const { invitedUsers } = this.state;

    const usersTExport = invitedUsers
      .filter((x) => x.userId && x.rsvp)
      .map((item) => ({
        name: `${item.userId.firstName || ""} ${item.userId.lastName || ""}`,
        email: item.userId.email,
        invitedOn: moment(item.date).format("MMM D, YYYY"),
        status: item.rsvp.label,
      }));
    return usersTExport;
  };

  renderRSVPcounts = () => {
    let { item } = this.props;
    let {
      invited_length,
      going_length,
      interested_length,
      updatedItem,
    } = this.state;
    // console.log('invite ---- ', updatedItem)
    // console.log('item ---- ', this.props.item)

    let event_invitee_count = calculateTotalRsvp(item, "invited");
    let event_interested_count = calculateTotalRsvp(item, "interested");
    let event_going_count = calculateTotalRsvp(item, "going");

    return (
      <div className="event_details_page_about_section_containers event_details_page_guests_section_containers">
        <span className="grp_create_page_privacy_status_details title">
          Guests
          <CSVLink
            className="event_details_page_guest_container_subtext_link ml-3"
            data={this.getEventsUsersData()}
            headers={eventUsersHeaders}
            filename={`${item.name}'s Members - ${moment().format(
              "MM/DD/YYYY"
            )}.csv`}
            target="_blank"
          >
            Export
          </CSVLink>
          <span
            className="event_details_page_guest_container_subtext_link"
            onClick={() => this.showGuestList()}
          >
            See all
          </span>
        </span>
        <span className="event_details_page_guests_metrics_container __invited">
          <span className="event_details_page_guests_count">
            {event_invitee_count}{" "}
          </span>
          <span className="event_details_page_guests_count_txt">INVITED</span>
        </span>
        <span className="event_details_page_guests_metrics_container __rsvp">
          <span className="event_details_page_guests_count">
            {event_interested_count}
          </span>
          <span className="event_details_page_guests_count_txt">
            INTERESTED
          </span>
        </span>
        <span className="event_details_page_guests_metrics_container __rsvp">
          <span className="event_details_page_guests_count">
            {event_going_count}
          </span>
          <span className="event_details_page_guests_count_txt">GOING</span>
        </span>
      </div>
    );
  };

  render() {
    let { item } = this.props;
    let {
      name,
      privacy,
      createdBy,
      description,
      category,
      subCategory,
      diversityFocus,
      relevantFor,
      rsvp_count,
      invitee_count,
      interested_count,
      going_count,
      invitedUsers,
      memberCount,
      startDate,
      endDate,
      location,
      isRecommendedByAdmin,
      avgRating,
      ratingsCount,
      website,
      attachments,
      attachment,
      image,
      comments,
      industryFocus,
      functionalFocus,
      bannerImg,
      webinar,
      categoryTypes,
      address,
      country,
      state,
      city,
      eventAddress,
    } = item;

    let {
      showGuestList,
      invited_length,
      going_length,
      interested_length,
    } = this.state;

    let total_people_responded = invitee_count + going_count + interested_count;

    let isWebinar =
      webinar && webinar.link && webinar.link.length > 0 ? true : false;

    if (attachment) {
      let idx = attachment.indexOf("-lg");
      let name = attachment.slice(idx + 3);
      attachments.concat({
        url: attachment,
        name,
        type: "",
      });
    }

    return (
      <span className="event_details_page_about_section">
        <div className="event_details_page_about_section_containers_meta">
          <div className="event_details_page_about_section_containers">
            <span className="grp_create_page_privacy_status_details title">
              Details
            </span>

            <div className="event_details_page_webinar_details_item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                className=""
                viewBox="0 0 16 16"
              >
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
              </svg>
              Event by
              {isRecommendedByAdmin != true ? (
                <span
                  className="event_details_page_webinar_details_item_owner"
                  onClick={() => this.goOwnerProfile(createdBy)}
                >
                  &nbsp;{createdBy.firstName} {createdBy.lastName}{" "}
                  <span className="user_gender_pronoun_toolsview">
                    {renderGenderPronoun(createdBy)}
                  </span>
                </span>
              ) : (
                <strong> Recommended</strong>
              )}
            </div>

            {this.props.item.groupId ? (
              <div className="event_details_page_webinar_details_item cursor-pointer">
                <img className="groupIcon" src={groupIcon} />
                Group Event
                <span
                  className="hyperlink_txt"
                  onClick={() => this.goToGroup()}
                >
                  (see group)
                </span>
              </div>
            ) : null}

            {category != "Diversity Calendar" ? (
              <div
                className="event_details_page_webinar_details_item cursor-pointer"
                onClick={() => this.showGuestList()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  className=""
                  viewBox="0 0 16 16"
                >
                  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                  <path
                    fillRule="evenodd"
                    d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                  />
                  <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                </svg>
                {calculateTotalRsvp(item, "rsvp")}{" "}
                <span className="event_details_page_webinar_details_rsvp_total">
                  people responded
                </span>
                <span className="hyperlink_txt">(view)</span>
              </div>
            ) : null}

            <div className="event_details_page_webinar_details_item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                className=""
                viewBox="0 0 16 16"
              >
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
              </svg>
              <div>
                <span className="">
                  Duration: {endDate ? getDuration(item) : "N/A"}
                </span>
                <span className="">{displayEventDates(item, true, true)}</span>
              </div>
            </div>

            {eventAddress ? (
              <div className="event_details_page_webinar_details_item">
                <BiMap size="18px" />{" "}
                <span>
                  {removePhraseBetweenCommas(eventAddress, "CAL Fire")}
                </span>
              </div>
            ) : (
              ""
            )}

            <div
              className="event_details_page_webinar_details_item"
              onClick={isWebinar ? () => this.goToWebinar(webinar.link) : null}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                className=""
                viewBox="0 0 16 16"
              >
                <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z" />
              </svg>
              <span className="single_event_description">
                {isWebinar ? (
                  <span>
                    {" "}
                    <a href={webinar.link} target="_blank">
                      {webinar.link}
                    </a>{" "}
                    (online)
                  </span>
                ) : (
                  <span className="txt_link_missing">
                    No online link provided
                  </span>
                )}
              </span>
            </div>

            <div className="event_details_page_webinar_details_item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
              </svg>
              <span
                dangerouslySetInnerHTML={this.createMarkup(description)}
                className="single_event_description"
              />
            </div>
          </div>

          {category != "Diversity Calendar" ? (
            <div className="event_details_page_about_section_containers event_details_page_about_host_section img_margin">
              <span className="grp_create_page_privacy_status_details title">
                Meet your Hosts
              </span>
              <span className="grp_create_page_privacy_status_details_txt">
                <div
                  className="grp_create_page_privacy_status_details"
                  onClick={() => this.goOwnerProfile(createdBy)}
                >
                  <div className="">
                    {profilePicValidityCheck(createdBy.profilePic) ? (
                      <img
                        src={createdBy.profilePic}
                        className="event_category_item_host_image"
                      />
                    ) : (
                      <span
                        className="event_category_item_host_image_initials"
                        data-letters={this.getInitials(createdBy)}
                      ></span>
                    )}
                    <span className="event_category_item_host_image_name">
                      {createdBy.firstName} {createdBy.lastName}
                    </span>
                    <span className="user_gender_pronoun_toolsview">
                      {renderGenderPronoun(createdBy)}
                    </span>
                  </div>
                </div>

                {item.invitedUsers && item.invitedUsers.length > 0
                  ? this.renderHosts()
                  : null}
              </span>
            </div>
          ) : null}
        </div>

        <div className="event_details_page_about_section_containers_meta">
          <div className="event_details_page_about_section_containers">
            <span className="grp_create_page_privacy_status_details title">
              Event Category
            </span>
            <span className="grp_create_page_privacy_status_details_txt">
              <div className="grp_create_page_privacy_status_details">
                <div className="event_category_item_container __category">
                  {category}
                </div>

                {subCategory && subCategory.subCategoryKey ? (
                  <div className="event_category_item_container __subcat">
                    {subCategory.subCategoryKey}
                  </div>
                ) : null}
              </div>
            </span>
          </div>

          <div className="event_details_page_about_section_containers">
            <span className="grp_create_page_privacy_status_details title">
              Diversity focus and relevant for
            </span>
            <span className="grp_create_page_privacy_status_details_txt">
              <div className="grp_create_page_privacy_status_details __diversityFocus">
                {diversityFocus.length > 0 ? (
                  diversityFocus.map((e) => {
                    return (
                      <span
                        key={e.key}
                        className="event_category_item_container __diveristy_focus"
                      >
                        {e.focus}
                      </span>
                    );
                  })
                ) : (
                  <span className="event_details_page_webinar_details_item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                    </svg>
                    There is no diversity focus for this event
                  </span>
                )}
              </div>

              <div className="grp_create_page_privacy_status_details __relevantFor">
                {relevantFor.length > 0 ? (
                  relevantFor.map((e) => {
                    return (
                      <span
                        key={e.key}
                        className="event_category_item_container __relevant_for"
                      >
                        {" "}
                        {e.focus}{" "}
                      </span>
                    );
                  })
                ) : (
                  <span className="event_details_page_webinar_details_item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                    </svg>
                    There is no relevant focus for this event.
                  </span>
                )}
              </div>
            </span>
          </div>

          {category != "Diversity Calendar" ? this.renderRSVPcounts() : null}

          <div className="event_details_page_about_section_containers event_details_about_resources_container">
            <span className="grp_create_page_privacy_status_details title">
              Event Resources
            </span>
            <div className="taskUploadPreviewContainer mb0">
              {attachments && attachments.length > 0 ? (
                this.renderUploadPreview(attachments)
              ) : (
                <span className="event_details_page_webinar_details_item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0zm-.861 1.542 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V7.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V7s1.54-1.274 1.639-1.208zM5 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z" />
                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                  </svg>
                  There are no resources for this event
                </span>
              )}
            </div>
          </div>
        </div>

        {showGuestList ? (
          <EventGuestsModal
            u_status={0}
            event={item}
            orgId={item.organizationID}
            isOpen={showGuestList}
            closeGuestList={this.closeGuestList}
            updateEventRsvp={this.props.updateEventRsvp}
          />
        ) : null}

        <span className="event_details_page_about_section_map">
          <EventsMap item={this.props.item} />
        </span>
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
    onToolInfoCompleted: (data) =>
      dispatch(actionCreators.toolInfoCompleted(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EventAbout)
);
